import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-form-field-error',
  templateUrl: './form-field-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./form-field-error.component.scss']
})
export class FormFieldErrorComponent {}
